import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalContext from "../../../../../Context/GlobalContext";
import Skeleton from "@mui/material/Skeleton";
import { Card, CardBody, CardTitle, CardSubtitle, CardText } from "reactstrap";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./SubscriptionsHome.css";
import SubscriptionCard from "../Subscriptions/Components/SubscriptionCard/SubscriptionCard";
import { useTranslation } from "react-i18next";

const GradientCardBody = styled(CardBody)`
  border-radius: 20px;
`;
const CardContainer = styled.div`
  margin: 0 auto; /* Adjust the margin to control the space between cards */
`;

export default function SubscriptionsHome() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const context = React.useContext(GlobalContext);
  const sliderSettings = {
    arrows: true,
    style: { maxWidth: "1100px", margin: "0 auto" },
    prevArrow: <div className="slick-prev"></div>,
    nextArrow: <div className="slick-next"></div>,
    infinite: false,
    dots: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1570, // For large screens
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          style: {
            maxWidth: "80%",
            margin: "0 auto",
          },
        },
      },
      {
        breakpoint: 1200, // For large screens
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          style: {
            maxWidth: "80%",
            margin: "0 auto",
          },
        },
      },
      {
        breakpoint: 768, // For small screens (phones)
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          style: {
            maxWidth: "80%",
            margin: "0 auto",
          },
        },
      },
    ],
  };

  if (!context.subs) {
    return (
      <div>
        <section className="">
          <Slider {...sliderSettings}>
            {Array.from({ length: 3 }).map((_, index) => (
              <CardContainer key={index}>
                <Card style={{ width: "18rem" }} className="h-100">
                  <Skeleton variant="rectangular" height={270} />
                  <GradientCardBody>
                    <CardTitle tag="h5">
                      <Skeleton variant="text" width={100} />
                    </CardTitle>
                    <CardSubtitle tag="h6">
                      <Skeleton variant="text" width={80} />
                    </CardSubtitle>
                    <CardText style={{ display: "flex", justifyContent: "center" }}>
                      <Skeleton variant="text" width={150} height={40} />
                    </CardText>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Skeleton variant="text" width={100} height={30} />
                    </div>
                  </GradientCardBody>
                </Card>
              </CardContainer>
            ))}
          </Slider>
        </section>
      </div>

    );
  }

  return (
    <div className="subscription_home">
      <Slider {...sliderSettings}>
        {context.subs.map((item) => (
          <SubscriptionCard key={item.id_subs} subs={item} />
        ))}
      </Slider>
      <div className="div-more">
        <center>
          <button
            className="btn-more"
            onClick={() => navigate("/subscriptions")}
            disabled={false}>
           {t("see_more_subscriptions")}
          </button>
        </center>
      </div>
    </div>
  );
}
